var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.singleStatus === 'loading')?_c('div',{staticClass:"flex items-center justify-center h-full"},[_c('ToznyLoader',{staticClass:"text-tozny w-8 h-8"})],1):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }